import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/Layout.css';

function Navbar({ user, onLogout, onCambiarPassword, toggleSidebar }) {
  const [showDropdown, setShowDropdown] = React.useState(false);
  const navigate = useNavigate();

  const handleCambiarPassword = () => {
    setShowDropdown(false);
    if (onCambiarPassword) {
      onCambiarPassword();
    }
  };

  const handleMiPerfil = () => {
    setShowDropdown(false);
    navigate('/perfil');
  };

  return (
    <nav className="top-navbar">
      <div className="navbar-left">
        <button className="hamburger-btn" onClick={toggleSidebar}>
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className="navbar-brand">
          <span className="brand-icon">🎓</span>
          <h1>AcademiK<span className="brand-pro">Pro</span></h1>
        </div>
      </div>

      <div className="navbar-right">
        <div className="user-menu" onClick={() => setShowDropdown(!showDropdown)}>
          <div className="user-avatar">
            {user.fullName.charAt(0).toUpperCase()}
          </div>
          <div className="user-info">
            <span className="user-name">{user.fullName}</span>
            <span className="user-profile">{user.role}</span>
          </div>
          <button className="dropdown-btn">▼</button>
        </div>

        {showDropdown && (
          <div className="user-dropdown">
            <div className="dropdown-item">
              <strong>{user.fullName}</strong>
              <span className="user-role-text">{user.role}</span>
            </div>
            <div className="dropdown-divider"></div>
            {user.role === 'Estudiante' && (
              <button className="dropdown-item" onClick={handleMiPerfil}>
                👤 Mi Perfil
              </button>
            )}
            <button className="dropdown-item" onClick={handleCambiarPassword}>
              🔐 Cambiar Contraseña
            </button>
            <button className="dropdown-item logout-btn" onClick={onLogout}>
              🚪 Cerrar Sesión
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;